import { getSessionId } from "../../authStorage";

export default () => `player:${getSessionId()}`;
